import { queryKeys } from '@/lib/query-keys';
import { useQuery } from '@tanstack/react-query';
import { billingClient } from '@/lib/api/ts-rest';

/**
 * Lightweight progress poll for the Publication step — hits `/progress`
 * (overview only, no per-center aggregation) and stops once published.
 */
export function useBillingRunProgress(runId: string | null) {
  return useQuery({
    queryKey: queryKeys.billing.runProgress(runId),
    queryFn: async () => {
      const res = await billingClient.getRunProgress({
        params: { id: runId! },
      });
      if (res.status !== 200) throw new Error('Failed to load progress');
      return res.body;
    },
    enabled: !!runId,
    refetchInterval: (query) =>
      query.state.data?.status === 'publishing' ? 1000 : false,
  });
}
